import { Actions } from "../slice";
import { call, takeLatest, put, select, debounce } from "redux-saga/effects";
import { Selectors as LocaleSelectors } from "@/store/locale/selectors";
import qs from "query-string";
import { Actions as BasketActions } from "../../basket/slice";
import { Selectors as BasketSelectors } from "../../basket/selectors";
import { SITE_URL } from "@/misc/constants";
import { ENABLE_MULTI_ITEM_BASKET } from "@/config";

function* normalizeShareLink(link) {
  const locale = yield select(LocaleSelectors.getLocale);
  if (link && !link.includes(SITE_URL)) {
    // probably some third-party url shortener was used
    // just return the link as it is
    return link;
  }
  const parsed = qs.parseUrl(
    link && typeof link === "string" ? link : window.location.href,
  );
  const normalized = qs.stringifyUrl({
    url: parsed.url,
    query: {
      ...parsed.query,
      hl: parsed.query.hl || locale,
    },
  });
  return normalized;
}
function* shareModalSaga({ payload: rawUrl }) {
  try {
    const url = yield call(normalizeShareLink, rawUrl);
    if (navigator.share) {
      yield navigator.share({
        url,
      });
    } else {
      yield put(Actions.openNonNativeShare(url));
    }
  } catch (e) {
    console.error(e);
  }
}

function* watchCloseBookingSaga() {
  if (
    !ENABLE_MULTI_ITEM_BASKET &&
    !(yield select(BasketSelectors.isBasketEmpty))
  ) {
    yield put(BasketActions.clearBasket());
  }
}
export default function* () {
  yield debounce(50, Actions.openShare.type, shareModalSaga);
  yield takeLatest(Actions.closeBooking.type, watchCloseBookingSaga);
}
